function queryString(values) {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.set(key, String(value).trim());
    }
  }
  return query.toString();
}

function buildApiReadRequest(name, params) {
  const eventId = params.EventID || params.EventId;
  const eventPath = eventId == null ? "" : encodeURIComponent(eventId);
  if (name === "GetEventProgram") {
    const query = queryString({ tag: params.Tags, search: params.Search });
    return { method: "GET", path: `/v1/events${query ? `?${query}` : ""}`, paginated: true };
  }
  if (name === "GetEventStats") return { method: "GET", path: `/v1/events/${eventPath}/stats` };
  if (name === "GetProgramStats") {
    return { method: "GET", path: `/v1/events/${eventPath}/programs/${encodeURIComponent(params.EventProgramID || params.ProgramID)}/stats` };
  }
  if (name === "GetEventParticipants" || name === "GetEventParticipantByEmail") {
    const query = name === "GetEventParticipantByEmail"
      ? queryString({ email: params.Email, limit: 500 })
      : queryString({ search: params.Search, include: "programs" });
    return { method: "GET", path: `/v1/events/${eventPath}/participants${query ? `?${query}` : ""}`, paginated: true };
  }
  if (name === "GetProgramParticipants") {
    const query = queryString({ search: params.Search });
    return { method: "GET", path: `/v1/events/${eventPath}/programs/${encodeURIComponent(params.EventProgramID || params.ProgramID)}/participants${query ? `?${query}` : ""}`, paginated: true };
  }
  return null;
}

module.exports = { buildApiReadRequest };
